// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCriteria from '../../../../shared/components/labeled-criteria';

const CreditMemoClaimNumberCriteria = props =>
    <div className='credit-memo-claim-number-criteria'>
        <LabeledCriteria
            className='invoice-request-criteria'
            isRequired={false}
            label='CLAIM_NUMBER'
            maxLength='17'
            onInputChange={props.handleClaimNumberInputChange}
            placeholder='CLAIM_NUMBER'
            type='text'
            value={props.claimNumberValue}
        />
    </div>;

CreditMemoClaimNumberCriteria.displayName = 'CreditMemoClaimNumberCriteria';
CreditMemoClaimNumberCriteria.propTypes = {
    claimNumberValue: PropTypes.string.isRequired,
    handleClaimNumberInputChange: PropTypes.func.isRequired
};

export default CreditMemoClaimNumberCriteria;




// WEBPACK FOOTER //
// ./src/reports/credit-memo/components/credit-memo-report-criteria/claim-number-criteria.js